import React, { Suspense }  from 'react';
import ReactDOM from 'react-dom/client';
import "./assets/css/tailwind.output.css";
import './index.css';
import { SidebarProvider } from "./context/SidebarContext";
import ThemedSuspense from "./components/ThemedSuspense";
import App from './App';
import theme from "./theme";

import { ThemeProvider } from "@material-tailwind/react";

import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

import store from "./store/index";
let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <SidebarProvider>
      <Suspense fallback={<ThemedSuspense />}>
        <ThemeProvider value={theme}>
          <App />
        </ThemeProvider>
        </Suspense>
      </SidebarProvider>
    </PersistGate>
  </Provider>
);

// serviceWorker.register();